import type { QueryKey } from '@tanstack/react-query';

import type { PaginatedResponse } from './api.ts';

export const getPageParamFromUrl = (url: string): number | undefined => {
    const page = Number(new URL(url, window.location.origin).searchParams.get('page'));
    return Number.isInteger(page) && page > 0 ? page : undefined;
};

interface PageQuery<T> {
    queryKey: QueryKey;
    queryFn: (context: { pageParam?: unknown; signal?: AbortSignal }) => Promise<PaginatedResponse<T>>;
    enabled?: boolean;
    staleTime?: number;
}

export const toInfiniteQuery = <T>(query: PageQuery<T>) => ({
    ...query,
    // Infinite data has a different shape from a single page or a flat list.
    queryKey: [...query.queryKey, 'infinite'],
    initialPageParam: 1,
    getNextPageParam: (page: PaginatedResponse<T>) => (page.next ? getPageParamFromUrl(page.next) : undefined),
    getPreviousPageParam: (page: PaginatedResponse<T>) =>
        page.previous ? getPageParamFromUrl(page.previous) : undefined,
});
